// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QipMQPdkdydS8I {
  display: flex;
  position: relative;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  width: fit-content;
  max-width: 100%;
  height: 24px;
  margin-bottom: var(--ds-space-050, 4px);
  padding: var(--ds-space-025, 2px);
  border-radius: var(--ds-border-radius-100, 3px);
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
}
.Wifl0mGs3Sckmk:hover {
  cursor: pointer;
  filter: saturate(85%) brightness(85%);
}
.N8gKbiQKzaWevI {
  background-color: var(--ds-background-accent-green-subtler, #baf3db);
  color: var(--ds-text-accent-green, #216e4e);
}
.N8gKbiQKzaWevI.WTAjJ1Lzg2YDct {
  background-color: var(--ds-background-success-bold, #1f845a);
  color: var(--ds-text-inverse, #ffffff);
}
.WziX3DCJLqaj_i {
  background-color: var(--ds-background-accent-yellow-subtler, #f8e6a0);
  color: var(--ds-text-accent-yellow, #7f5f01);
}
.WziX3DCJLqaj_i.WTAjJ1Lzg2YDct {
  background-color: var(--ds-background-warning-bold, #e2b203);
  color: var(--ds-text-inverse, #ffffff);
  color: var(--ds-text-warning-inverse, #172b4d);
}
.OSOi5_f1ldmQv1 {
  background-color: var(--ds-background-accent-orange-subtler, #ffe2bd);
  color: var(--ds-text-accent-orange, #974f0c);
}
.OSOi5_f1ldmQv1.WTAjJ1Lzg2YDct {
  background-color: var(--ds-background-accent-orange-bolder, #b65c02);
  color: var(--ds-text-inverse, #ffffff);
}
.E2CUsdbTIKSRzp {
  background-color: var(--ds-background-accent-red-subtler, #ffd2cc);
  color: var(--ds-text-accent-red, #ae2a19);
}
.E2CUsdbTIKSRzp.WTAjJ1Lzg2YDct {
  background-color: var(--ds-background-danger-bold, #ca3521);
  color: var(--ds-text-inverse, #ffffff);
}
.a5slN758mxFoYr {
  background-color: var(--ds-background-accent-purple-subtler, #dfd8fd);
  color: var(--ds-text-accent-purple, #5e4db2);
}
.a5slN758mxFoYr.WTAjJ1Lzg2YDct {
  background-color: var(--ds-background-accent-purple-bolder, #6e5dc6);
  color: var(--ds-text-inverse, #ffffff);
}
.xp7wyaIhcdefw2 {
  background-color: var(--ds-background-accent-blue-subtler, #cce0ff);
  color: var(--ds-text-accent-blue, #0055cc);
}
.xp7wyaIhcdefw2.WTAjJ1Lzg2YDct {
  background-color: var(--ds-background-accent-blue-bolder, #0c66e4);
  color: var(--ds-text-inverse, #ffffff);
}
.nUFGale7g9IuqO {
  background-color: var(--ds-background-accent-teal-subtler, #c1f0f5);
  color: var(--ds-text-accent-teal, #206b74);
}
.nUFGale7g9IuqO.WTAjJ1Lzg2YDct {
  background-color: var(--ds-background-accent-teal-bolder, #1d7f8c);
  color: var(--ds-text-inverse, #ffffff);
}
.N0olzwGeWzR2Ev {
  background-color: var(--ds-background-accent-magenta-subtler, #fdd0ec);
  color: var(--ds-text-accent-magenta, #943d73);
}
.N0olzwGeWzR2Ev.WTAjJ1Lzg2YDct {
  background-color: var(--ds-background-accent-magenta-bolder, #ae4787);
  color: var(--ds-text-inverse, #ffffff);
}
.McGNOe003Y402q {
  background-color: var(--ds-background-accent-lime-subtler, #d3f1a7);
  color: var(--ds-text-accent-lime, #4c6b1f);
}
.McGNOe003Y402q.WTAjJ1Lzg2YDct {
  background-color: var(--ds-background-accent-lime-bolder, #5b7f24);
  color: var(--ds-text-inverse, #ffffff);
}
.nG9aN6BhA_n5YT {
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
  color: var(--ds-text-accent-gray, #44546f);
}
.fB5OgqJL9W_S59 {
  background-color: var(--ds-background-accent-gray-subtler, #dcdfe4);
  color: var(--ds-text-accent-gray, #44546f);
}
.fB5OgqJL9W_S59.WTAjJ1Lzg2YDct {
  background-color: var(--ds-background-accent-gray-bolder, #626f86);
  color: var(--ds-text-inverse, #ffffff);
}
.body-color-blind-mode-enabled .xZOy5E3NxB0rKu {
  padding-left: var(--ds-space-250, 20px);
}
.body-color-blind-mode-enabled .xZOy5E3NxB0rKu::before {
  content: '';
  position: absolute;
  top: var(--ds-space-0, 0);
  bottom: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  width: 16px;
  border-radius: var(--ds-border-radius-100, 4px) 0 0 var(--ds-border-radius-100, 4px);
  mask-repeat: repeat-y;
}
.zaWVOrlZlwvTRs {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  line-height: 20px;
}
.nGT0DJOrI676qn {
  padding-right: var(--ds-space-050, 4px);
  padding-left: var(--ds-space-025, 2px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.nGT0DJOrI676qn:first-child {
  padding-left: var(--ds-space-050, 4px);
}
`, ""]);
// Exports
export var badge = `QipMQPdkdydS8I`;
var _1 = `Wifl0mGs3Sckmk`;
export { _1 as "badge--isInteractive" };
var _2 = `N8gKbiQKzaWevI`;
export { _2 as "badge--green" };
var _3 = `WTAjJ1Lzg2YDct`;
export { _3 as "badge--isBold" };
var _4 = `WziX3DCJLqaj_i`;
export { _4 as "badge--yellow" };
var _5 = `OSOi5_f1ldmQv1`;
export { _5 as "badge--orange" };
var _6 = `E2CUsdbTIKSRzp`;
export { _6 as "badge--red" };
var _7 = `a5slN758mxFoYr`;
export { _7 as "badge--purple" };
var _8 = `xp7wyaIhcdefw2`;
export { _8 as "badge--blue" };
var _9 = `nUFGale7g9IuqO`;
export { _9 as "badge--sky" };
var _a = `N0olzwGeWzR2Ev`;
export { _a as "badge--pink" };
var _b = `McGNOe003Y402q`;
export { _b as "badge--lime" };
var _c = `nG9aN6BhA_n5YT`;
export { _c as "badge--gray" };
var _d = `fB5OgqJL9W_S59`;
export { _d as "badge--black" };
var _e = `xZOy5E3NxB0rKu`;
export { _e as "badge--hasColorBlindPattern" };
export var badgeIcon = `zaWVOrlZlwvTRs`;
export var badgeText = `nGT0DJOrI676qn`;
export default ___CSS_LOADER_EXPORT___;
